// import React, { useState, useRef, useContext } from "react";
// import {
//   View,
//   Text,
//   Pressable,
//   StyleSheet,
//   TouchableOpacity,
// } from "react-native";
// import { Image } from "react-native";
// import { PanResponder } from "react-native";
// import Svg, { Path } from "react-native-svg";
// import { AppContext } from "../../App";

// const COLORS = {
//   primary: "#1CA7AE",
//   primarySoft: "#E7F6F7",
//   background: "rgba(0,0,0,0.45)",
//   card: "#FFFFFF",
//   textDark: "#1C1C1E",
//   textMuted: "#6B7280",
//   border: "#E5E7EB",
// };

// export default function ConsentModal({ onDismiss, navigation }) {
//   const { setFormProgress } = useContext(AppContext);

//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);
//   const [paths, setPaths] = useState([]);
//   const [signatureDrawn, setSignatureDrawn] = useState(false);
//   const [sigSize, setSigSize] = useState({ width: 0, height: 0 });

//   const isFormValid = isChecked && signatureDrawn;

//   /** 🔒 PAN RESPONDER — FIXED */
//   const panResponder = useRef(
//     PanResponder.create({
//       onStartShouldSetPanResponder: () => true,
//       onMoveShouldSetPanResponder: () => true,
//       onPanResponderTerminationRequest: () => false,
//       onPanResponderGrant: (evt) => {
//         const { locationX, locationY } = evt.nativeEvent;
//         setPaths((prev) => [...prev, [{ x: locationX, y: locationY }]]);
//         setSignatureDrawn(true);
//       },
//       onPanResponderMove: (evt) => {
//         const { locationX, locationY } = evt.nativeEvent;
//         setPaths((prev) => {
//           if (!prev.length) return prev;
//           const updated = [...prev];
//           updated[updated.length - 1] = [
//             ...updated[updated.length - 1],
//             { x: locationX, y: locationY },
//           ];
//           return updated;
//         });
//       },
//     })
//   ).current;

//   const buildPathD = (points) =>
//     points.reduce(
//       (acc, p, i) => acc + `${i === 0 ? "M" : "L"}${p.x} ${p.y} `,
//       ""
//     );

//   const handleClear = () => {
//     setPaths([]);
//     setSignatureDrawn(false);
//   };

//   const handleAccept = () => {
//     if (!isFormValid) return;

//     setFormProgress((prev) => ({
//       ...prev,
//       completedSteps: [...prev.completedSteps, "consent_modal"],
//       currentStep: "find_immatriculation_or_chasis_number_screen",
//     }));

//     navigation.navigate("find_immatriculation_or_chasis_number_screen");
//     onDismiss?.();
//   };

//   return (
//     <View style={styles.overlay} pointerEvents="box-none">
//       {/* Block touches behind */}
//       <View style={styles.backdrop} />

//       {/* FIXED MODAL */}
//       <View style={styles.modalWrapper} pointerEvents="box-none">
//         <View style={styles.modalCard} pointerEvents="auto">
//           <Text style={styles.title}>
//             Consentement au traitement des données
//           </Text>

//           <Text style={styles.subtitle}>
//             Conformément à la loi n°2024/017 du 23 décembre 2024
//           </Text>

//           {/* Expand agreement */}
//           <Pressable
//             style={[
//               styles.expandBox,
//               isExpanded && styles.expandBoxActive,
//             ]}
//             onPress={() => setIsExpanded((p) => !p)}
//           >
//             <View style={styles.expandHeader}>
//               <Image
//                 source={require("../../assets/handshake.png")}
//                 style={[
//                   styles.icon,
//                   { tintColor: isExpanded ? "#FFF" : COLORS.primary },
//                 ]}
//               />
//               <Text
//                 style={[
//                   styles.expandLabel,
//                   isExpanded && { color: "#FFF" },
//                 ]}
//               >
//                 Voir l’accord complet
//               </Text>
//             </View>

//             {isExpanded && (
//               <Text style={styles.expandText}>
//                 Je consens au traitement de mes données personnelles dans
//                 le cadre de la procédure de vérification du véhicule.
//               </Text>
//             )}
//           </Pressable>

//           {/* Checkbox */}
//           <Pressable
//             style={styles.checkboxRow}
//             onPress={() => setIsChecked((p) => !p)}
//           >
//             <View
//               style={[
//                 styles.checkbox,
//                 isChecked && styles.checkboxChecked,
//               ]}
//             >
//               {isChecked && <Text style={styles.tick}>✓</Text>}
//             </View>
//             <Text style={styles.checkboxText}>
//               J’accepte les conditions
//             </Text>
//           </Pressable>

//           {/* Signature */}
//           <Text style={styles.signatureTitle}>Signature</Text>

//           <View
//             style={styles.signatureBox}
//             onLayout={(e) => setSigSize(e.nativeEvent.layout)}
//             {...panResponder.panHandlers}
//           >
//             <Svg
//               width={sigSize.width}
//               height={sigSize.height}
//               style={StyleSheet.absoluteFill}
//             >
//               {paths.map((p, i) => (
//                 <Path
//                   key={i}
//                   d={buildPathD(p)}
//                   stroke="#000"
//                   strokeWidth={3}
//                   fill="none"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               ))}
//             </Svg>
//             {!signatureDrawn && (
//               <Text style={styles.signatureHint}>Signer ici</Text>
//             )}
//           </View>

//           <TouchableOpacity onPress={handleClear}>
//             <Text style={styles.clearText}>Effacer la signature</Text>
//           </TouchableOpacity>

//           {/* CTA */}
//           <Pressable
//             disabled={!isFormValid}
//             onPress={handleAccept}
//             style={[
//               styles.acceptButton,
//               !isFormValid && { opacity: 0.5 },
//             ]}
//           >
//             <Text style={styles.acceptText}>Accepter</Text>
//           </Pressable>
//         </View>
//       </View>
//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   overlay: {
//     ...StyleSheet.absoluteFillObject,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   backdrop: {
//     ...StyleSheet.absoluteFillObject,
//     backgroundColor: COLORS.background,
//   },
//   modalWrapper: {
//     width: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   modalCard: {
//     width: "90%",
//     maxWidth: 520,
//     backgroundColor: COLORS.card,
//     borderRadius: 20,
//     padding: 20,
//     elevation: 10,
//   },
//   title: {
//     fontSize: 20,
//     fontWeight: "800",
//     textAlign: "center",
//   },
//   subtitle: {
//     fontSize: 13,
//     textAlign: "center",
//     color: COLORS.textMuted,
//     marginBottom: 16,
//   },
//   expandBox: {
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderRadius: 12,
//     padding: 12,
//     marginBottom: 16,
//   },
//   expandBoxActive: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//   },
//   expandHeader: {
//     flexDirection: "row",
//     alignItems: "center",
//     gap: 8,
//   },
//   expandLabel: {
//     fontWeight: "600",
//     color: COLORS.primary,
//   },
//   expandText: {
//     marginTop: 8,
//     color: "#FFF",
//     fontSize: 14,
//   },
//   icon: {
//     width: 20,
//     height: 20,
//   },
//   checkboxRow: {
//     flexDirection: "row",
//     alignItems: "center",
//     marginBottom: 12,
//   },
//   checkbox: {
//     width: 22,
//     height: 22,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderRadius: 6,
//     marginRight: 8,
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   checkboxChecked: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//   },
//   tick: {
//     color: "#FFF",
//     fontWeight: "bold",
//   },
//   checkboxText: {
//     fontSize: 14,
//   },
//   signatureTitle: {
//     fontSize: 14,
//     fontWeight: "600",
//     marginBottom: 6,
//   },
//   signatureBox: {
//     height: 100,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderRadius: 12,
//     marginBottom: 8,
//     justifyContent: "center",
//   },
//   signatureHint: {
//     position: "absolute",
//     alignSelf: "center",
//     color: COLORS.textMuted,
//   },
//   clearText: {
//     color: COLORS.primary,
//     fontSize: 13,
//     marginBottom: 16,
//   },
//   acceptButton: {
//     backgroundColor: COLORS.primary,
//     borderRadius: 14,
//     paddingVertical: 14,
//     alignItems: "center",
//   },
//   acceptText: {
//     color: "#FFF",
//     fontSize: 16,
//     fontWeight: "700",
//   },
// });// ConsentModal.jsx (updated)
// ✅ Fixes:
// 1) Language switch stays clickable (top area not blocked)
// 2) Popup has spacing from top (like your first image)
// 3) Backdrop still dims, but does NOT capture clicks
// 4) NO scrolling in the main consent popup (kept your compact logic)
// 5) Nothing else changed



import React, { useMemo, useState, useContext } from "react";
import {
  View,
  Text,
  Pressable,
  StyleSheet,
  Modal,
  ScrollView,
  Platform,
  useWindowDimensions,
} from "react-native";
import { Image } from "react-native";
import { AppContext } from "../../App";
import { useTranslation } from "../i18n";

import AgreementRenderer from "../legal/AgreementRenderer";

// ✅ IMPORTANT: match your real export names
import { consentAgreementBlocksEN } from "../legal/consentAgreementBlocks.en";
import { consentAgreementBlocksFR } from "../legal/consentAgreementBlocks.fr";

const COLORS = {
  primary: "#1CA7AE",
  background: "rgba(0,0,0,0.45)",
  card: "#FFFFFF",
  textDark: "#1C1C1E",
  textMuted: "#6B7280",
  border: "#E5E7EB",
  shadow: "#000",
};

// ✅ This is the key: keep header clickable by NOT covering it with the backdrop.
// Tune these if your header is taller/shorter.
const HEADER_CLEARANCE =
  Platform.OS === "web" ? 145 : Platform.OS === "ios" ? 110 : 100;

export default function ConsentModal({ onDismiss, navigation }) {
  const { setFormProgress } = useContext(AppContext);
  const { t, currentLang } = useTranslation();
  const { height } = useWindowDimensions();

  const [isChecked, setIsChecked] = useState(false);
  const [fullOpen, setFullOpen] = useState(false);

  const isFormValid = isChecked;

  // ✅ Pick EN/FR blocks based on language
  const blocks = useMemo(() => {
    return (currentLang || "en").startsWith("fr")
      ? consentAgreementBlocksFR
      : consentAgreementBlocksEN;
  }, [currentLang]);

  // ✅ Compact layout on small heights (prevents ANY scroll)
  const isCompact = height < 760;
  const previewItems = isCompact ? 10 : 14;
  const previewMinHeight = isCompact ? 120 : 160;

  const handleAccept = () => {
    if (!isFormValid) return;

    setFormProgress((prev) => ({
      ...prev,
      completedSteps: [...prev.completedSteps, "consent_modal"],
      currentStep: "find_immatriculation_or_chasis_number_screen",
    }));

    navigation.navigate("find_immatriculation_or_chasis_number_screen");
    onDismiss?.();
  };

  return (
    <View style={styles.overlay} pointerEvents="box-none">
      {/* ✅ Backdrop starts BELOW the header so header remains clickable */}
      <View style={styles.backdrop} pointerEvents="auto" />

      {/* ✅ Modal area (also starts lower so it doesn't touch the header) */}
      <View
        style={[
          styles.modalWrapper,
          isCompact && styles.modalWrapperCompact,
          { paddingTop: HEADER_CLEARANCE + (isCompact ? 16 : 24) },
        ]}
        pointerEvents="box-none"
      >
        <View
          style={[styles.modalCard, isCompact && styles.modalCardCompact]}
          pointerEvents="auto"
        >
          <Text style={[styles.title, isCompact && styles.titleCompact]}>
            {t("consent.title")}
          </Text>
          <Text style={[styles.subtitle, isCompact && styles.subtitleCompact]}>
            {t("consent.subtitle")}
          </Text>

          {/* Agreement Preview */}
          <View
            style={[styles.agreementCard, isCompact && styles.agreementCardCompact]}
          >
            <View
              style={[
                styles.agreementHeader,
                isCompact && styles.agreementHeaderCompact,
              ]}
            >
              <View style={styles.agreementHeaderLeft}>
                <View
                  style={[
                    styles.docIconWrap,
                    isCompact && styles.docIconWrapCompact,
                  ]}
                >
                  <Image
                    source={require("../../assets/handshake.png")}
                    style={[styles.docIcon, { tintColor: "#FFF" }]}
                  />
                </View>
                <Text
                  style={[
                    styles.agreementTitle,
                    isCompact && styles.agreementTitleCompact,
                  ]}
                >
                  {t("consent.fullAgreementTitle")}
                </Text>
              </View>

              <Pressable
                onPress={() => setFullOpen(true)}
                style={({ pressed }) => [
                  styles.chevBtn,
                  isCompact && styles.chevBtnCompact,
                  pressed && { opacity: 0.7 },
                ]}
                hitSlop={12}
              >
                <Text style={[styles.chev, isCompact && styles.chevCompact]}>
                  ⌃
                </Text>
              </Pressable>
            </View>

            <View style={[styles.previewWrap, { minHeight: previewMinHeight }]}>
              <AgreementRenderer blocks={blocks} maxItems={previewItems} />
              <View style={styles.previewFade} pointerEvents="none" />
            </View>

            <Pressable
              onPress={() => setFullOpen(true)}
              style={({ pressed }) => [
                styles.readFullBtn,
                isCompact && styles.readFullBtnCompact,
                pressed && { opacity: 0.9 },
              ]}
            >
              <Text
                style={[
                  styles.readFullText,
                  isCompact && styles.readFullTextCompact,
                ]}
              >
                {t("consent.readFullAgreement")}
              </Text>
              <Text
                style={[
                  styles.readFullArrow,
                  isCompact && styles.readFullArrowCompact,
                ]}
              >
                ›
              </Text>
            </Pressable>
          </View>

          {/* Checkbox */}
          <Pressable
            style={[styles.checkboxRow, isCompact && styles.checkboxRowCompact]}
            onPress={() => setIsChecked((p) => !p)}
          >
            <View style={[styles.checkbox, isChecked && styles.checkboxChecked]}>
              {isChecked && <Text style={styles.tick}>✓</Text>}
            </View>
            <Text style={[styles.checkboxText, isCompact && styles.checkboxTextCompact]}>
              {t("consent.acceptConditions")}
            </Text>
          </Pressable>

          {/* CTA */}
          <Pressable
            disabled={!isFormValid}
            onPress={handleAccept}
            style={[
              styles.acceptButton,
              isCompact && styles.acceptButtonCompact,
              !isFormValid && styles.acceptButtonDisabled,
            ]}
          >
            <Text style={[styles.acceptText, isCompact && styles.acceptTextCompact]}>
              {t("consent.accept")}
            </Text>
          </Pressable>
        </View>
      </View>

      {/* Full Agreement Modal (scroll stays here) */}
      <Modal
        transparent
        visible={fullOpen}
        animationType="fade"
        onRequestClose={() => setFullOpen(false)}
      >
        <View style={styles.fullOverlay}>
          <Pressable
            style={StyleSheet.absoluteFillObject}
            onPress={() => setFullOpen(false)}
          />
          <View style={styles.fullCard}>
            <View style={styles.fullHeader}>
              <Text style={styles.fullTitle}>{t("consent.fullAgreementTitle")}</Text>
              <Pressable
                onPress={() => setFullOpen(false)}
                hitSlop={12}
                style={({ pressed }) => pressed && { opacity: 0.7 }}
              >
                <Text style={styles.closeX}>✕</Text>
              </Pressable>
            </View>

            <ScrollView
              style={styles.fullBody}
              contentContainerStyle={styles.fullBodyContent}
              showsVerticalScrollIndicator
            >
              <AgreementRenderer blocks={blocks} />
            </ScrollView>

            <Pressable
              onPress={() => setFullOpen(false)}
              style={({ pressed }) => [
                styles.fullCloseBtn,
                pressed && { opacity: 0.9 },
              ]}
            >
              <Text style={styles.fullCloseText}>{t("common.continue")}</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    elevation: 9999,
    justifyContent: "center",
    alignItems: "center",
  },

  // ✅ IMPORTANT: do NOT cover the header area
  backdrop: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    top: HEADER_CLEARANCE, // <-- starts under header
    backgroundColor: COLORS.background,
  },

  modalWrapper: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 14,
    paddingBottom: 22,
  },
  modalWrapperCompact: {
    paddingBottom: 16,
  },

  modalCard: {
    width: "100%",
    maxWidth: 560,
    backgroundColor: COLORS.card,
    borderRadius: 28,
    paddingVertical: 22,
    paddingHorizontal: 20,
    shadowColor: COLORS.shadow,
    shadowOpacity: 0.18,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 12 },
    elevation: 10,
  },
  modalCardCompact: {
    borderRadius: 24,
    paddingVertical: 16,
    paddingHorizontal: 16,
  },

  title: {
    fontSize: 22,
    fontWeight: "800",
    textAlign: "center",
    color: COLORS.textDark,
  },
  titleCompact: { fontSize: 20 },

  subtitle: {
    marginTop: 6,
    fontSize: 13.5,
    textAlign: "center",
    color: COLORS.textMuted,
    marginBottom: 14,
  },
  subtitleCompact: { marginBottom: 10 },

  agreementCard: {
    borderRadius: 18,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "rgba(28,167,174,0.25)",
    backgroundColor: "rgba(28,167,174,0.08)",
    marginBottom: 18,
  },
  agreementCardCompact: { marginBottom: 12 },

  agreementHeader: {
    backgroundColor: COLORS.primary,
    paddingVertical: 14,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  agreementHeaderCompact: { paddingVertical: 12, paddingHorizontal: 12 },

  agreementHeaderLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    flexShrink: 1,
  },

  docIconWrap: {
    width: 34,
    height: 34,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.18)",
    alignItems: "center",
    justifyContent: "center",
  },
  docIconWrapCompact: { width: 30, height: 30, borderRadius: 9 },
  docIcon: { width: 18, height: 18 },

  agreementTitle: {
    color: "#FFF",
    fontWeight: "800",
    fontSize: 18,
    flexShrink: 1,
  },
  agreementTitleCompact: { fontSize: 16 },

  chevBtn: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.16)",
  },
  chevBtnCompact: { paddingHorizontal: 8, paddingVertical: 5, borderRadius: 9 },
  chev: {
    color: "#FFF",
    fontSize: 18,
    lineHeight: 18,
    marginTop: Platform.OS === "android" ? 1 : 0,
    fontWeight: "700",
  },
  chevCompact: { fontSize: 17 },

  previewWrap: {
    backgroundColor: "rgba(255,255,255,0.92)",
    paddingHorizontal: 14,
    paddingTop: 14,
    paddingBottom: 10,
  },
  previewFade: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: 44,
    backgroundColor: "rgba(255,255,255,0.96)",
    opacity: 0.98,
  },

  readFullBtn: {
    backgroundColor: "rgba(28,167,174,0.85)",
    paddingVertical: 14,
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },
  readFullBtnCompact: { paddingVertical: 12 },
  readFullText: { color: "#FFF", fontSize: 16, fontWeight: "800" },
  readFullTextCompact: { fontSize: 15 },
  readFullArrow: {
    color: "#FFF",
    fontSize: 22,
    lineHeight: 22,
    marginTop: -1,
    fontWeight: "700",
  },
  readFullArrowCompact: { fontSize: 20 },

  checkboxRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
    paddingHorizontal: 4,
  },
  checkboxRowCompact: { marginBottom: 10 },
  checkbox: {
    width: 24,
    height: 24,
    borderWidth: 1.5,
    borderColor: COLORS.border,
    borderRadius: 7,
    marginRight: 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFF",
  },
  checkboxChecked: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
  tick: { color: "#FFF", fontWeight: "900", fontSize: 14 },
  checkboxText: { fontSize: 15, color: COLORS.textDark, flexShrink: 1 },
  checkboxTextCompact: { fontSize: 14 },

  acceptButton: {
    backgroundColor: COLORS.primary,
    borderRadius: 18,
    paddingVertical: 16,
    alignItems: "center",
    shadowColor: COLORS.shadow,
    shadowOpacity: 0.12,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 6,
  },
  acceptButtonCompact: { paddingVertical: 14, borderRadius: 16 },
  acceptButtonDisabled: { opacity: 0.45 },
  acceptText: { color: "#FFF", fontSize: 18, fontWeight: "900" },
  acceptTextCompact: { fontSize: 17 },

  fullOverlay: {
    flex: 1,
    backgroundColor: COLORS.background,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 14,
  },
  fullCard: {
    width: "100%",
    maxWidth: 640,
    maxHeight: "82%",
    backgroundColor: "#FFF",
    borderRadius: 22,
    overflow: "hidden",
    shadowColor: COLORS.shadow,
    shadowOpacity: 0.2,
    shadowRadius: 26,
    shadowOffset: { width: 0, height: 14 },
    elevation: 12,
  },
  fullHeader: {
    paddingHorizontal: 16,
    paddingVertical: 14,
    backgroundColor: "rgba(28,167,174,0.10)",
    borderBottomWidth: 1,
    borderBottomColor: COLORS.border,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  fullTitle: {
    fontSize: 16,
    fontWeight: "900",
    color: COLORS.textDark,
    flexShrink: 1,
  },
  closeX: { fontSize: 18, fontWeight: "900", color: COLORS.textMuted },
  fullBody: { flex: 1 },
  fullBodyContent: { padding: 16, paddingBottom: 20 },
  fullCloseBtn: { backgroundColor: COLORS.primary, paddingVertical: 14, alignItems: "center" },
  fullCloseText: { color: "#FFF", fontSize: 16, fontWeight: "900" },
});
